import { z } from 'zod'
import { logRequestFailure } from '@/helpers/request-outcome'
import { api } from '@/helpers/apiClient'
import { billingRedirectDtoSchema, type BillingRedirectDto } from '@lib/dto/billing-redirect.dto'

/** The billing owner's billing — the web side of `BillingController`. */
class BillingService {
  async checkout(): Promise<BillingRedirectDto> {
    try {
      return await api.post('/billing/checkout', {}, billingRedirectDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to start checkout', {}, error)
      throw error
    }
  }

  async completeCheckout(sessionId: string): Promise<void> {
    try {
      await api.post('/billing/checkout/complete', { sessionId }, z.null())
    } catch (error) {
      logRequestFailure('Failed to complete checkout', {}, error)
      throw error
    }
  }

  async portal(): Promise<BillingRedirectDto> {
    try {
      return await api.post('/billing/portal', {}, billingRedirectDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to open the billing portal', {}, error)
      throw error
    }
  }

  async cancel(): Promise<void> {
    try {
      await api.post('/billing/cancel', {}, z.null())
    } catch (error) {
      logRequestFailure('Failed to cancel the subscription', {}, error)
      throw error
    }
  }

  async resume(): Promise<void> {
    try {
      await api.post('/billing/resume', {}, z.null())
    } catch (error) {
      logRequestFailure('Failed to undo the cancellation', {}, error)
      throw error
    }
  }
}

export const billingService = new BillingService()
